export default {"src":"/_next/static/media/back-top-arrow.62e44c63.svg","height":20,"width":12,"blurWidth":0,"blurHeight":0};